// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-content-title {
  color: var(--planeed-black);
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
}

.text-content {
  color: var(--planeed-black);
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 21px;
}

.text-content-bold {
  color: var(--planeed-black);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}

.text-content-bold-blue {
  color: var(--planeed-blue);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}

.content-link {
  color: var(--planeed-blue);
  text-decoration: none;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  margin-left: 5px;
}

.content-link:hover {
  text-decoration: underline;
}

.text-small-gray {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.24px;
  color: var(--planeed-gray);
}

#mapEl {
  height: 100vh;
  width: 100%;
}

.map-container {
  position: relative;
  height: 100%;
  width: 100%;
}

.map-canvas {
  height: 100%;
  width: 100%;
  transform: none !important;
}

.mapboxgl-ctrl-bottom-right {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 2rem;
}

.mapboxgl-ctrl-group button:first-child {
  padding: 10px !important;
  height: 40px !important;
  width: 40px !important;
}

.mapboxgl-ctrl-group button:last-child {
  padding: 10px !important;
  height: 40px !important;
  width: 40px !important;
}

.mapboxgl-ctrl-group button + button {
  padding: 10px !important;
  height: 40px !important;
  width: 40px !important;
}

.mapboxgl-ctrl button:not(:disabled):hover {
  background-color: white !important;
}

.mapboxgl-marker {
  overflow: visible;
}

.side-panel {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 30vw;
  max-width: 680px;
  display: flex;
  flex-direction: column;
  background: var(--planeed-color-white);
  box-shadow: -4px 0 10px 0 rgba(0, 0, 0, 0.15);
  z-index: 20;
  opacity: 0;
  pointer-events: none;
  transform: translateX(100%);
  transition: transform 240ms ease, opacity 240ms ease;
  will-change: transform;
}

.map-container.panel-open .side-panel {
  transform: translateX(0);
  opacity: 1;
  pointer-events: auto;
}

.panel-header {
  display: flex;
  align-items: center;
  padding: 20px;
}

.side-panel-back {
  font-size: 20px;
  cursor: pointer;
}

.mapboxgl-popup-content {
  background-color: var(--planeed-color-white);
  border-radius: 10px !important;
  margin-bottom: 25px;
  box-shadow: 0 4px 8px 1px rgba(1, 33, 36, 0.5);
  padding: 5px !important;
  height: 100% !important;
  width: 100%;
}

.map-hover-popup-moment {
  padding-top: 5px;
  padding-left: 5px;
  padding-right: 5px;
  height: 100%;
  width: 100%;
  border-radius: 10px;
}

.mapboxgl-popup-tip {
  display: none;
}

.mapboxgl-popup {
  width: 100% !important;
}

.map-hover-popup-moment-img {
  border-radius: 10px;
}

.mr-5 {
  margin-right: 5px;
}

.ml-5 {
  margin-left: 5px;
}

.content-link-container {
  display: flex;
  align-items: center;
  margin: 12px 0;
}

ion-modal::part(handle) {
  width: 60px;
  height: 3px;
  margin-top: 1rem;
  background-color: var(--ion-color-secondary);
}

.marker-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.marker {
  cursor: pointer;
  border-radius: 8px;
}

/* --- Moment --- */
.marker-moment {
  background-color: #fff;
  background-size: cover;
  background-position: center;
  width: 40px;
  height: 50px;
  box-shadow: 0 4px 8px 1px rgba(1, 33, 36, 0.5);
}

/* --- Organization --- */
.marker-organization {
  background-color: #fff;
  background-size: cover;
  background-position: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 8px 1px rgba(1, 33, 36, 0.5);
}

/* --- Space --- */
.marker-space {
  background-color: #fff;
  background-size: cover;
  background-position: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0 4px 8px 1px rgba(1, 33, 36, 0.5);
}

/* --- Default --- */
.marker-poa {
  background-size: contain;
  background-position: center;
  background-color: transparent;
  width: 40px;
  height: 40px;
  border-radius: 0;
}

/* Label */
.marker-label {
  margin-top: 4px;
  font-size: 16px;
  font-weight: 500;
  color: var(--planeed-blue);
  line-height: 18px;
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
  transition: opacity 0.2s ease;
  opacity: 0;
  pointer-events: none;
}

.marker-wrapper:hover .marker-label {
  opacity: 1;
}

.marker-wrapper.selected .marker-label {
  opacity: 1;
}

app-impact-map,
ion-content,
.map-container,
#map {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

ion-button {
  --color: transparent;
}

.map-label {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  background: white;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  padding: 10px 30px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
  color: var(--ion-color-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
}

.map-label ion-icon {
  margin-left: 10px;
}

.push-info-text-container {
  display: flex;
  flex-direction: column;
  margin-right: 3rem;
}

.push-info {
  position: absolute;
  bottom: 2%;
  right: 40%;
  transform: translateX(50%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
  background-color: var(--ion-color-secondary);
  color: var(--planeed-color-white);
  padding: 10px 15px;
  font-size: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  opacity: 0;
  transition: right 0.35s ease, opacity 0.35s ease, transform 0.35s ease;
}

.push-info.show {
  animation: fadeInUp 0.35s ease forwards;
}

.push-info.hiding {
  animation: fadeOutDown 0.35s ease forwards;
}

.push-info.show {
  opacity: 1;
  transform: translateY(0);
  transition-delay: 0.05s;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeOutDown {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(20px);
  }
}
.push-info.show {
  animation: fadeInUp 0.35s ease forwards;
}

.push-filter {
  font-weight: bold;
}

.map-container {
  position: relative;
}

/* Overlay fade */
.map-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 55, 61, 0.2);
  z-index: 2;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}
.map-overlay.show {
  opacity: 1;
  pointer-events: auto;
}

@media only screen and (max-width: 460px) {
  .map-label {
    position: absolute;
    width: 100%;
    top: 40px;
    background: white;
    padding: 0 20px;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
    color: var(--ion-color-secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    border-radius: 0;
  }
  .map-label-app {
    position: absolute;
    width: 100%;
    top: 55px;
    background: white;
    padding: 0 20px;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
    color: var(--ion-color-secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    border-radius: 0;
  }
  .map-label ion-icon {
    margin-left: 0;
  }
  .push-info-text-container {
    margin-right: 0;
  }
  .push-info {
    width: 75%;
    bottom: 10px;
    left: auto;
    transform: translateX(-58%) translateY(10px);
    font-size: 12px;
    padding: 0 12px;
  }
  .push-info.show {
    opacity: 1;
    transform: translateX(-58%) translateY(0);
  }
  .push-info.hiding {
    opacity: 0;
    transform: translateX(-58%) translateY(10px);
  }
  .push-info ion-icon {
    font-size: 16px;
  }
}
.map-hover-overlay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  background: var(--planeed-color-white);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  width: 400px;
  z-index: 9999;
  opacity: 0;
  transform: translateY(5px);
  pointer-events: none;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}
.map-hover-overlay.show {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.map-search {
  z-index: 1;
}

.search-icon-container {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  position: absolute;
  z-index: 2;
  top: 12px;
  right: 12px;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 10px;
  background-color: var(--planeed-color-white);
  transition: background-color 0.3s ease, transform 0.2s ease;
}
.search-icon-container ion-icon {
  font-size: 20px;
}

@media only screen and (max-width: 460px) {
  .search-icon-container {
    top: 110px;
  }
}
.search-icon-container:active {
  transform: scale(0.9);
}

.search-icon-container.active {
  background-color: var(--planeed-blue);
}
.search-icon-container.active ion-icon {
  font-size: 20px;
}

.searchbar {
  position: absolute;
  z-index: 1;
  opacity: 1;
  transform: translateX(50%);
  pointer-events: auto;
  transition: 0.35s ease;
}

.searchbar-pos-normal {
  top: 18px;
  right: 50%;
}
@media only screen and (max-width: 460px) {
  .searchbar-pos-normal {
    top: 50px;
  }
}

.searchbar-pos-left-top {
  top: 85px;
  right: calc(100% - 170px);
}

.searchbar-panel-open-tall {
  top: 18px;
}
@media only screen and (min-width: 1260px) and (max-width: 2560px) {
  .searchbar-panel-open-tall {
    right: calc(35% + 620px);
  }
}
@media only screen and (min-width: 2560px) {
  .searchbar-panel-open-tall {
    right: calc(35% + 740px);
  }
}

ion-searchbar.custom-map-search {
  --background: var(--planeed-color-white);
  --border-radius: 20px;
  --clear-button-color: var(--planeed-red);
  --color: var(--planeed-blue);
  --placeholder-color: var(--planeed-gray);
  --placeholder-font-weight: 400;
  --placeholder-opacity: 1;
  width: 300px;
  transform: scaleY(1.1);
}
ion-searchbar.custom-map-search::part(container) {
  height: 40px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
}
ion-searchbar.custom-map-search::part(input) {
  height: 40px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
}

.searchbar-ios .searchbar-clear-icon {
  background-image: url("/src/assets/icon/impact_map/search-icon.svg");
}

ion-list {
  background-color: var(--planeed-color-white);
  border-radius: 10px;
  padding: 0;
}

ion-item {
  --background: var(--planeed-color-white);
}

ion-item:last-child {
  border-bottom: none;
}

.side-panel {
  z-index: 1000;
}

.fly-to-position,
.legend-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 10;
  cursor: pointer;
  width: 40px;
  height: 40px;
  background-color: var(--planeed-color-white);
  font-size: 20px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  right: 30px;
  border-radius: 50%;
  transition: 0.35s ease;
}
.fly-to-position ion-icon,
.legend-button ion-icon {
  fill: #00373d;
  transition: fill 0.35s ease;
}
.fly-to-position:hover ion-icon,
.legend-button:hover ion-icon {
  fill: var(--ion-color-warning);
}

ion-icon {
  fill: #00373d;
}

.fly-to-position {
  bottom: 30px;
}

.legend-button {
  bottom: 90px;
}

.map-logo {
  position: absolute;
  top: 30px;
  left: 30px;
  z-index: 10;
  width: 150px;
  height: 35px;
  cursor: pointer;
}

.logo-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media only screen and (max-width: 460px) {
  .fly-to-position,
  .legend-button {
    right: 5px;
    bottom: 10px;
  }
  .legend-button {
    bottom: 65px;
  }
}
.cover-box {
  background: var(--ion-color-light);
  height: 150px;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
  font-size: 25px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  background-color: transparent;
}

.cover-box img {
  object-fit: cover;
  height: 150px;
  width: 100%;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  background-color: transparent;
}

.photo-box {
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
  font-size: 25px;
  position: relative;
  border-radius: 50%;
  border: 4px solid white;
  padding: 1px;
  margin-left: 15px;
  height: 100px;
  margin-top: -50px;
  background-color: var(--planeed-color-white);
}

.photo-box img {
  border-radius: 50%;
  width: 90px;
  height: 90px;
  object-fit: cover;
}

.content {
  padding: 0 10px;
  background-color: var(--planeed-color-white);
}

.title {
  color: var(--ion-color-text-color);
  font-size: 17px;
}

.stats-container {
  margin: 20px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
